module.exports = __webpack_public_path__ + "assets/merriweather-bolditalic.93576fbb86ee19973c5255f1d3a5a8f1.woff";